// extracted by mini-css-extract-plugin
export default {"testPreview":"testPreview-JkWvX","white":"white-cS26Q"};